import { render } from "./NewBus.vue?vue&type=template&id=a3ca4a36"
import script from "./NewBus.vue?vue&type=script&lang=js"
export * from "./NewBus.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__